<template>
	<div class="mb_db learner_program_data">

		<div class="row">
      <div class="col-12">

				<b-card class="text-center prog-lmi" role="button" v-bind:style="{ backgroundImage: 'url(' + course.thumbnail + ')'}" style="background-size: cover;">
					<btn v-if="course.ltiCourse" class="crd_lg_btn ace_sec" @click="showDesktopAppInfoModal">
						<div class="ic ic24-project"></div>
					</btn>
					<btn v-else class="crd_lg_btn ace_sec" @click="continueLearning">
						<div class="ic ic24-course"></div>
					</btn>

					<template v-if="courseStream.uuid">
						<div class="crd_content">
						<b-card-text>
							<div class="program_status_select_bx">
								<div class="progress-row">
									<div class="progress-bar-label ace_sec_txt" :aria-label="score + '%'">{{score}}%</div>
									<b-progress :max="childrenCount">
										<b-progress-bar :value="childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
									</b-progress>
								</div>
							</div>
						</b-card-text>
						</div>
						<div class="row">
							<div class="col-12 footer-box" v-if="!transactionValidity.transactionValid">
								<div class="row alert_msg_sec">
									<div class="col-9 msg_container">
										<span v-html="transactionValidity.institutionPurchaseExpirationMessage"></span>
									</div>
									<div class="col-3 btn_container" v-if="!transactionValidity.programSwitched && !transactionValidity.inactive">
										<b-btn @click="navigateToSelectedProgram">Renew</b-btn>
									</div>
								</div>
							</div>
							<div class="col-12 footer-box" v-if="transactionValidity.transactionValid && userObject.suspended">
								<div class="row alert_msg_sec">
									<div class="col-9 msg_container">
												<span v-html="institution.userSuspensionMessage">
												</span>
									</div>
								</div>
							</div>

							<div class="col-12 footer-box" v-if="transactionValidity.transactionValid && !userObject.suspended">
								<div class="lnk_container row">
									<div class="col-10 footer-title">
										{{courseStream.title}}
									</div>
									<div class="col-2 btn_container" v-if="releaseStatus">
										<b-btn class="btn btn_ic" :aria-label="buttonLabel" size="sm">
											<span class="ic ic24-arrowCircle1"></span>
										</b-btn>
									</div>
									<div class="col-1 btn_container" v-if="!releaseStatus">
										<b-link class="btn_lock_unlock" v-b-modal="'releaseModal_' + course.uuid">
											<span class="ic22-lock"></span>
										</b-link>
									</div>
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<div class="crd_content">
							<b-card-text>
								<div class="mt-4">
									<span v-if="isCourseCompleted">Congratulations, you have completed the course.</span>
									<span v-else>Learning data not available.</span>
								</div>
							</b-card-text>
						</div>
					</template>
				</b-card>

      </div>
    </div>

		<div class="modal_popup_container course_unlock_modal">
			<b-modal ref="unlockCourseModal" class="description_modal" size="md" :id="'releaseModal_' + course.uuid" ok-only ok-title="ok">
				<div slot="modal-header" class="header-section">
					<div class="ic_container">
						<span class="ic ic22-lock"></span>
					</div>
					<div class="head_txt">Course is Locked</div>
					<div class="btn_container">
						<button type="button" class="btn_close" @click="hideUnlockCourseInfoModal" data-dismiss="modal" aria-label="Close">
							<span class="ic-close"></span>
						</button>
					</div>
				</div>

				<div class="row">
					<div class="col-12 txt_row">
						{{course.title}}
					</div>
					<div class="col-12 txt_row">
						<div v-html="releaseLogicDetail"></div>
					</div>
				</div>

			</b-modal>
		</div>

		<div class="modal_popup_container course_unlock_modal">
			<b-modal ref="ssoCourseModal" class="description_modal" size="md" :id="'ssoModal_' + course.uuid" hide-footer>
				<div slot="modal-header" class="header-section">
					<div class="head_txt">Reconfirm Credentials </div>
					<div class="btn_container">
						<button type="button" class="btn_close" @click="hideSsoCourseInfoModal" data-dismiss="modal" aria-label="Close">
							<span class="ic-close"></span>
						</button>
					</div>
				</div>

				<div class="row">
					<div class="col-12 txt_row mt-3">
						We need to reconfirm your credentials, before you can access the course.
					</div>
					<div class="col-12 txt_row btn_container mt-3" style="text-align: right;">
						<b-button class="btn mr-3" @click="redirectToSsoLogin">login to course</b-button>
					</div>
				</div>

			</b-modal>
		</div>

		<div class="modal_popup_container">
			<b-modal ref="desktopInfoModal" class="description_modal" size="md" :id="'desktopInfoModal_' + course.uuid" hide-footer>
				<div slot="modal-header" class="header-section">
					<div class="head_txt"></div>
					<div class="btn_container">
						<button type="button" class="btn_close" @click="hideDesktopAppInfoModal" data-dismiss="modal" aria-label="Close">
							<span class="ic-close"></span>
						</button>
					</div>
				</div>

				<div class="row">
					<div class="col-12 txt_row mt-3">
						Please use a desktop to work on the project! To learn the concepts you can use a desktop or mobile!!
					</div>
					<div class="col-12 txt_row btn_container mt-3" style="text-align: right;">
						<b-button class="btn mr-3" @click="hideDesktopAppInfoModal">ok</b-button>
					</div>
				</div>

			</b-modal>
		</div>

	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapState, mapActions } from 'vuex'
	//import {Stretch} from 'vue-loading-spinner'
	import VClamp from 'vue-clamp'

	export default {
		name: 'learner-program-course-learn-v2',
		components: {
			VClamp,
			//Stretch
		},
    props: ['program', 'courseStream'],
    data: () => {
    	return {
    		course: {},
    		releaseStatus :true,
    		releaseLogicDetail: '',
    		buttonLabel: '',
    		selectedProgram: {},
    		isCourseCompleted: false,
        transactionValidity: {transactionValid:true},
        childrenCompleteCount : 0,
        childrenCount : 1,
        score : 0
    	}
    },

    beforeMount () {
    },

    mounted () {
    	this.$nextTick(() => {
    		this.$nextTick(() => {
	    		setTimeout(() => {
		    		this.loadCourseAndProgress()
		    	}, 500)
	    	})
    	})
    },

    methods: {
			...mapActions([
        'loadCompetencyProgressForCourseAndUser',
        'loadContinueLearningLast',
        'loadCourseDetail',
        'loadCheckTransactionValidity'
      ]),
      navigateToSelectedProgram () {
        let routerParams = {
          cipCode: this.selectedProgram.programCipCode,
          programGuideCode: this.selectedProgram.programCode,
          type: this.selectedProgram.programType,
          returnTo: 'learnerDashboard',
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideIntroduction', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      },
      async loadCourseAndProgress (programCode) {
      	this.course = await this.loadCourseDetail(this.courseStream.originUuid)
      	this.releaseStatus = true
      	this.releaseLogicDetail = ''
      	this.selectedProgram = {}
        this.transactionValidity = {transactionValid:true}
      	this.isCourseCompleted = false

      	this.isCourseCompleted = false
      	let competencySummary = await this.loadCompetencyProgressForCourseAndUser(this.courseStream.originUuid)
				if (!this.isCourseCompleted) {
					this.buttonLabel = (competencySummary.status === 0) ? 'Start Learning' : 'Continue Learning'
				}else{
						this.buttonLabel = 'View Course'
				}
        this.childrenCount = competencySummary.childrenCount
        this.childrenCompleteCount = competencySummary.childrenCompleteCount
        if(this.childrenCount>0){
        	this.score = 100*(this.childrenCompleteCount / this.childrenCount).toFixed(2)
        }
        this.releaseStatus = this.courseStream.releaseStatus
        this.releaseLogicDetail = this.courseStream.releaseLogicDetail
        this.transactionValidity = await this.loadCheckTransactionValidity(this.program.code)
      },
			continueLearning () {
				this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        let courseId = this.course.uuid
        this.loadContinueLearningLast(courseId).then(options => {
          if (options && options.length > 0) {
            if (options[0].title === 'EXTRENAL_COURSE_LAUNCH' && options[0].type ==='SSOCOURSE' && !this.userObject.ssoLogin) {
            	this.$refs.ssoCourseModal.show()
            	return
            }else {
	            if (options[0].title === 'EXTRENAL_COURSE_LAUNCH') {
	              let _window = window.open(options[0].uri, '_blank')
	               setTimeout(() => {
	            			_window.location = options[1].uri
	          			}, 5000)
	              return
	            }
	            if (options[0].title === 'PARTNER_COURSE_LAUNCH') {
	            		window.location.href = options[0].uri
	              return
	            }

	            if (options[0].title !== 'COURSE_FINISHED') {
	              return this.$router.push({name: 'courseDashboard', params: {uuid: courseId, showLastActivity: true}})
	            }
	           }
          }
          return this.$router.push({name: 'courseDashboard', params: {uuid: courseId}})
        })
			},
			hideUnlockCourseInfoModal () {
				this.$refs.unlockCourseModal.hide()
			},
			hideSsoCourseInfoModal () {
				this.$refs.ssoCourseModal.hide()
			},
			showDesktopAppInfoModal () {
				this.$refs.desktopInfoModal.show()
			},
			hideDesktopAppInfoModal () {
				this.$refs.desktopInfoModal.hide()
			},
			redirectToSsoLogin (){
					let ssoPath = this.institution.path
					window.location.href = '/sso/'+ssoPath
			},
      setThumbnailTitle (title) {
        if ((title.indexOf('-') !== -1) && (title.indexOf('-') < 7)) {
          let splitted = title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return title.substring(0, 7)
      }
		},
		watch: {
	    courseStream (newObject) {
	    		if(newObject){
	    				this.loadCourseAndProgress()
	    		}
	    }
	  },

		computed: {
      ...mapState({
    		'institution': state => state.dashboard.institution,
    		'userObject': state => state.login.userObj,
    		'institution': state => state.dashboard.institution,
        'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData
      }),
      getBgImage () {
 					return 'https://pragya2-staging.s3-us-west-2.amazonaws.com/672142121d1ca40729d86480-bed-1.jpg?versionId=jrioD6WGwzZ3ZqWr7Fdv9CXzBM1Mwi8z'
 //     	return this.course.thumbnail
      }
    }
	}
</script>

<style scoped>
  .prog-lmi .card-header {
    height: 65px;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProgramCourseLearnV2.vue